import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from '@ff-os/shared-react/components/radio-group/Radio';
import { SizeChoiceOptions } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import { SizeAttributeLabel } from '../shared/SizeAttributeLabel';
import styles from './SizeAttributeRadio.module.scss';

export const SizeAttributeRadio = ({
    options, value, label,
    active, onClick
}: Props) => {
    const { t } = useTranslation();
    return (
        <Radio key={value} value={value} label={t(label)}
            active={active}
            onClick={() => onClick(value)}>
            <SizeAttributeLabel label={label} value={value} options={options} />
            {options?.assetUrl && (
                <img className={styles.preview}
                    src={options.assetUrl}
                    alt={t(label)} />
            )}
        </Radio>
    );
};

type Props = {
    label: string;
    value: string;
    options?: SizeChoiceOptions;
    active: boolean;
    onClick: (value: string) => void;
};